(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Shop menu logo resize functionality
  document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    
    // Function to add shop menu active class
    function activateShopMenu() {
      body.classList.add('shop-menu-active');
    }
    
    // Function to remove shop menu active class
    function deactivateShopMenu() {
      body.classList.remove('shop-menu-active');
    }
    
    // Find all menu items that contain "shop" in text or have shop-related attributes
    const allMenuItems = document.querySelectorAll('.header__menu-item, summary.header__menu-item');
    
    allMenuItems.forEach(function(menuItem) {
      const text = menuItem.textContent.toLowerCase().trim();
      const href = menuItem.getAttribute('href') || '';
      
      // Check if this is a shop menu item
      if (text.includes('shop') || href.includes('/collections') || href.includes('shop')) {
        menuItem.addEventListener('click', function(e) {
          activateShopMenu();
        });
        
        // If this is a summary element (dropdown), listen for toggle
        if (menuItem.tagName.toLowerCase() === 'summary') {
          const details = menuItem.closest('details');
          if (details) {
            details.addEventListener('toggle', function() {
              if (this.open) {
                activateShopMenu();
              } else {
                setTimeout(deactivateShopMenu, 300);
              }
            });
          }
        }
      }
    });
    
    // Also listen for clicks on any collection links
    document.addEventListener('click', function(e) {
      const target = e.target.closest('a');
      if (target) {
        const href = target.getAttribute('href') || '';
        if (href.includes('/collections')) {
          activateShopMenu();
        }
      }
    });
    
    // Reset on home page load
    if (window.location.pathname === '/') {
      deactivateShopMenu();
    }
    
    // Test function - add to window for manual testing
    window.testShopMenu = function() {
      if (body.classList.contains('shop-menu-active')) {
        deactivateShopMenu();
      } else {
        activateShopMenu();
      }
    };

    // Mobile Search Toggle Functionality
    const mobileSearchContainer = document.getElementById('mobile-search-container');
    const mobileSearchClose = document.getElementById('mobile-search-close');
    const isMobile = () => window.innerWidth <= 990;

    if (mobileSearchContainer) {
      // Open mobile search when clicking the search icon/container on mobile
      mobileSearchContainer.addEventListener('click', function(e) {
        if (isMobile() && !this.classList.contains('mobile-search-active')) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.add('mobile-search-active');

          // Focus the search input after a small delay
          setTimeout(() => {
            const input = document.getElementById('header-search-input');
            if (input) input.focus();
          }, 100);
        }
      });

      // Close mobile search
      if (mobileSearchClose) {
        mobileSearchClose.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeMobileSearch();
        });
      }

      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileSearchContainer.classList.contains('mobile-search-active')) {
          closeMobileSearch();
        }
      });

      function closeMobileSearch() {
        mobileSearchContainer.classList.remove('mobile-search-active');
        const input = document.getElementById('header-search-input');
        if (input) input.value = '';
        hideHeaderResults();
      }
    }

    // Header Live Search Functionality
    const headerSearchInput = document.getElementById('header-search-input');
    const headerSearchResults = document.getElementById('header-search-results');
    const headerSearchForm = document.getElementById('header-search-form');
    let headerSearchTimeout;

    if (headerSearchInput && headerSearchResults) {
      headerSearchInput.addEventListener('input', function() {
        clearTimeout(headerSearchTimeout);
        const query = this.value.trim();

        if (query.length < 3) {
          hideHeaderResults();
          return;
        }

        showHeaderLoading();

        headerSearchTimeout = setTimeout(() => {
          performHeaderSearch(query);
        }, 300);
      });

      headerSearchInput.addEventListener('blur', function() {
        // Delay hiding to allow clicking on results
        setTimeout(() => {
          hideHeaderResults();
        }, 200);
      });

      headerSearchInput.addEventListener('focus', function() {
        if (this.value.trim().length >= 3 && headerSearchResults.innerHTML.trim()) {
          headerSearchResults.classList.add('active');
        }
      });
    }

    function showHeaderLoading() {
      headerSearchResults.innerHTML = '<div class="header__search-loading">Searching...</div>';
      headerSearchResults.classList.add('active');
    }

    function hideHeaderResults() {
      headerSearchResults.classList.remove('active');
    }

    function performHeaderSearch(query) {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=12`)
        .then(response => response.json())
        .then(data => {
          displayHeaderResults(data.resources.results.products || []);
        })
        .catch(error => {
          console.error('Header search error:', error);
          headerSearchResults.innerHTML = '<div class="header__search-no-results">Search unavailable</div>';
        });
    }

    function displayHeaderResults(products) {
      if (products.length === 0) {
        headerSearchResults.innerHTML = '<div class="header__search-no-results">No products found</div>';
        return;
      }

      // Sort products: in-stock first
      products.sort((a, b) => {
        const aInStock = a.available ? 1 : 0;
        const bInStock = b.available ? 1 : 0;
        return bInStock - aInStock;
      });

      const resultsHTML = products.map(product => {
        // Handle price - Shopify API can return price as string or number, in dollars or cents
        let price = '';
        if (product.price) {
          // Convert to string first to check format
          const priceStr = String(product.price);
          const priceNum = parseFloat(priceStr);

          // If price contains a decimal point, it's already in dollars (e.g., "120.00")
          // If no decimal or looks like cents (e.g., "12000"), divide by 100
          if (priceStr.includes('.')) {
            price = priceNum.toFixed(2).replace('.00', '');
          } else {
            price = (priceNum / 100).toFixed(2).replace('.00', '');
          }
        }
        const stockStatus = product.available ? 'in-stock' : 'out-of-stock';
        const stockText = product.available ? 'In Stock' : 'Out of Stock';

        // Format image URL properly for Shopify
        let imageUrl = '';
        if (product.featured_image) {
          // Handle both string URLs and image objects
          const imageSource = typeof product.featured_image === 'string'
            ? product.featured_image
            : (product.featured_image.url || product.featured_image);

          if (imageSource && typeof imageSource === 'string') {
            imageUrl = imageSource.includes('http')
              ? imageSource
              : `https:${imageSource}`;
            // Add size parameter for consistent image sizing
            imageUrl = imageUrl.replace(/(\.(jpg|jpeg|png|gif|webp))/, '_150x150$1');
          }
        }

        return `
          <a href="${product.url}" class="header__search-result">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" class="header__result-image" loading="lazy">` : `
              <div class="header__result-image" style="background-color: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999; font-size: 10px;">
                No Image
              </div>
            `}
            <div class="header__result-content">
              <h4 class="header__result-title">${product.title}</h4>
              ${price ? `<p class="header__result-price">$${price}</p>` : ''}
            </div>
          </a>
        `;
      }).join('');

      headerSearchResults.innerHTML = resultsHTML;
    }

    // Handle menu link clicks vs dropdown toggle
    document.addEventListener('click', function(e) {
      // Check if the click is on a menu link inside a summary
      if (e.target.closest('.header__menu-link')) {
        const menuLink = e.target.closest('.header__menu-link');
        const summary = menuLink.closest('summary');
        
        if (summary) {
          // Allow the link to navigate
          e.stopPropagation();
          // Don't prevent default - let the link work normally
        }
      }
      
      // Check if the click is on the toggle area (arrow)
      else if (e.target.closest('.header__menu-toggle')) {
        // This will trigger the dropdown toggle naturally
        // No additional action needed
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
